import { AGGREGATE_NAMES, CHAT_RESOLVERS } from 'cpool-constants';

import { DEFAULT_MESSAGE_PAGE_SIZE } from '~/features/whatsapp/constants';
import { searchParamsForQueryKey } from '~/queryUtils/useQuery';

// The trailing 'infinite' segment keeps this key distinct from useMessages's single-page key.
export const getChatMessagesInfiniteQueryKey = (chatId: string, limit = DEFAULT_MESSAGE_PAGE_SIZE) =>
    [AGGREGATE_NAMES.CHAT, CHAT_RESOLVERS.getMessages, searchParamsForQueryKey({ chatId, limit }), 'infinite'] as const;
